import { useEffect } from 'react';
import { makeStyles } from '@mui/styles';
import { useQuery } from '@tanstack/react-query';
import { Outlet, useLocation, useNavigate, useParams } from 'react-router';

import PageLoading from 'src/components/loadings/PageLoading';
import { routes } from 'src/routes';
import publicConroller from 'src/services/leaderboard/publicController';

import 'src/assets/CSS/Admin.scss';

export const useStyles = makeStyles((theme) => ({
  root: {
    '& > *': {
      // margin: theme.spacing(1),
      width: '25ch',
    },
  },
  gridList: {
    width: '100%',
    height: 'auto',
  },
  select: {
    '&:before': {
      borderColor: 'white !important',
    },
    '&:after': {
      borderColor: 'white !important',
    },
    '&:not(.Mui-disabled):hover::before': {
      borderColor: 'white !important',
    },
    color: 'white !important',
    background: '#202429 !important',
  },
  icon: {
    fill: 'white !important',
  },
  accordion: {
    background: 'linear-gradient(180deg, #041128, #1e1826) !important',
    borderRadius: '10px',
    color: 'white !important',
  },
  chip: {
    color: 'white !important',
    background: '#121418 !important',
    backgroundColor: '#121418 !important',
    border: '1px solid #2a2e38 !important',
    cursor: 'pointer !important',
  },
  card: {
    minWidth: 100,
    maxHeight: 100,
    height: '100%',
    backgroundColor: 'transparent !important',
    margin: '15px',
    border: 'none',
    boxShadow: 'none',
  },
  chipSelected: {
    backgroundSize: 'cover',
    height: '50px',
    textAlign: 'left',
    fontSize: '11px !important',
    color: '#cecece',
    cursor: 'pointer !important',
    backgroundColor: '#080808',
    border: '3px solid #886CFF !important',
  },
  cardContent: {
    backgroundSize: 'cover',
    backgroundColor: '#080808',
    height: '56px',
    border: '2px solid #2a2e38',
    textAlign: 'left',
    fontSize: '11px !important',
    color: '#cecece',
  },
}));

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
export const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
      color: '#acacac',
      background: '#121418',
    },
  },
};

export const dialogStyles = {
  backgroundColor: '#1a1d23',
  color: 'white',
  padding: '25px',
  boxShadow: 'none',
};

export interface ModalProps {
  open: boolean;
  onClose: () => void;
}

export default function VipLayout() {
  const location = useLocation();
  const navigate = useNavigate();
  const params = useParams();

  const {
    data: sponsorsData = [],
    isLoading: isFetchingSponsors,
    isFetching,
  } = useQuery({
    queryKey: ['sponsors'],
    queryFn: () => publicConroller.getSponsors(),
  });

  //TODO: Need to show Shuffle sponsor first, in the future it should be via backend
  useEffect(() => {
    const isVipWithoutSponsor =
      location.pathname === routes.vip && sponsorsData?.length > 0;
    const isVipWithoutLocationState =
      !location.state?.sponsor && sponsorsData?.length > 0;

    if (isVipWithoutSponsor) {
      redirectShuffleSponsor();
    } else if (!isVipWithoutSponsor && isVipWithoutLocationState) {
      redirectSponsorByName(params.id);
    }
  }, [sponsorsData, location.pathname]);

  useEffect(() => {
    if (sponsorsData?.length > 0 && location?.state?.sponsor?.id) {
      updateLocationStateSponsor();
    }
  }, [isFetching]);

  const updateLocationStateSponsor = () => {
    const findSponsor = sponsorsData.find(
      (sponsor) =>
        sponsor.name === location?.state.sponsor?.name ||
        sponsor.name === splitCamelCase(location?.state?.sponsor?.name),
    );

    if (!findSponsor) {
      redirectShuffleSponsor();
    }

    redirectToSponsor(findSponsor);
  };

  const redirectShuffleSponsor = () => {
    const findSponsor = sponsorsData.find((sponsor) =>
      sponsor.name.toLowerCase().includes('shuffle'),
    );

    redirectToSponsor(findSponsor);
  };

  const redirectSponsorByName = (sponsorName?: string) => {
    if (!sponsorName) {
      redirectShuffleSponsor();

      return;
    }

    const findSponsor = sponsorsData.find(
      (sponsor) =>
        sponsor.name === sponsorName ||
        sponsor.name === splitCamelCase(sponsorName),
    );

    redirectToSponsor(findSponsor);
  };

  const redirectToSponsor = (findSponsor: any) => {
    const currentSponsor = findSponsor ? findSponsor : sponsorsData[0];

    const urlSponsorName = currentSponsor.name.replace(/\s+/g, '');

    navigate(routes.vipSponsor.replace(':id', urlSponsorName), {
      state: { sponsor: currentSponsor },
    });
  };

  const splitCamelCase = (sponsorName: string) => {
    return sponsorName.replace(/([a-z])([A-Z])/g, '$1 $2');
  };

  if (isFetchingSponsors) {
    return <PageLoading />;
  }

  return (
    <>
      <Outlet />
    </>
  );
}
